import DocumentsTab from '../components/DocumentsTab'
import EventsTab from '../components/EventsTab'
import PaymentAdvancesTab from '../components/PaymentAdvancesTab'
import ResumeTab from '../components/ResumeTab'
import SupplyAuthorizationsTab from '../components/SupplyAuthorizationsTab'

export const billingBillTabs = ({
  billType,
  needSupplyAuthorization,
}: {
  billType?: string
  needSupplyAuthorization?: boolean
}) => [
  {
    label: 'Resumo',
    value: '',
    body: <ResumeTab />,
  },
  {
    label: 'Nota fiscal / Cobranças',
    value: 'documents',
    body: <DocumentsTab />,
  },
  {
    label: 'Transações',
    value: 'events',
    body: <EventsTab type={billType} />,
  },
  {
    label: 'Antecipáveis',
    value: 'payment-advances',
    body: <PaymentAdvancesTab />,
    hidden: billType !== 'establishment_bills',
  },
  {
    label: 'AFs',
    value: 'supply-authorizations',
    body: <SupplyAuthorizationsTab />,
    hidden: billType !== 'client_bills' || !needSupplyAuthorization,
  },
]
